export const LIVE_STREAMING_OPTIONS_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.LiveStreamingOptionsWidgetElement';
